import { useMemo } from 'react';
import { RecordData, ValidationRule } from '../types';
import { getNestedValue } from '../utils/nestedData';

export const useValidation = (formData: RecordData, rules: ValidationRule[]) => {
  return useMemo(() => {
    const errors: Record<string, string> = {};

    rules.forEach(rule => {
      const value = getNestedValue(formData, rule.field);

      if (rule.type === 'required' && (value === undefined || value === '' || value === null)) {
        errors[rule.field] = rule.message;
      }
      
      if (value !== undefined && value !== null && value !== '') {
        if (rule.type === 'regex' && rule.value instanceof RegExp && !rule.value.test(String(value))) {
          errors[rule.field] = rule.message;
        }
        if (rule.type === 'min' && Number(value) < rule.value) {
          errors[rule.field] = rule.message;
        }
        if (rule.type === 'max' && Number(value) > rule.value) {
          errors[rule.field] = rule.message;
        }
      }
    });

    return errors;
  }, [formData, rules]);
};
